import {writable} from 'svelte/store';
import Config from '../Config';
import Gallery from '../States/Gallery';
import Helper from '../Models/Helper';
import Render from '../States/Render';

let content = {api: {}, price: 0, properties: [], options: false, options_top: false, basket: false, info: false, erp: 0};
const product = writable(content);

function setRender() {
	Render.layer(0, content.api.images.render);
	for (let part of content.api.parts)
		for (let property of part.properties)
			for (let option of property.options)
				if (option.active && Helper.is(option.images.render)) {
					const image = option.images.render;
					Render.layer(property.layer, image);
			}

	Render.commit();
}

function setGallery() {
	for (let part of content.api.parts)
		for (let property of part.properties)
			for (let option of property.options)
				if (option.active) {
					const gallery = option.images.gallery;
					Gallery.option(property.code, gallery.small, gallery.large);
				}

	Gallery.commit();
}

function getPrice() {
	let total = content.api.price;
	for (let part of content.api.parts)
		for (let property of part.properties)
			for (let option of property.options)
				if (option.active)
					total += option.price;

	for (let upgrade of content.api.upgrades)
		if (upgrade.active)
			total += upgrade.price;

	return total;
}

/* Public */

product.update = () => {
	setRender();
	setGallery();

	content.price = getPrice();
	product.set(content);
};

product.shopify = async id => {
	const url = Helper.endpoint(`products/${id}`);
	const response = await fetch(url);
	content.api = await response.json();

	for (let part of content.api.parts)
		for (let property of part.properties) {
			property.counter = 0;
			if (!Helper.undefined(property.defaults))
				for (let index in property.defaults)
					for (let item of property[index])
						if (item.code == property.defaults[index])
							item.active = true;
		}

	product.update();
};

product.erp = async id => {
	const url = Helper.endpoint(`states/${id}`);
	const response = await fetch(url);
	content.api = await response.json();
	content.erp = id;
	product.update();
};

export default product;